const GET_QUESTIONS_COURSE = (state) => {
  return state.questions;
};
const GET_LOADDING = (state) => {
  return state.loadding;
};
const GET_QUESTION_EDIT = (state) => {
  return state.edit;
};
const GET_QUESTION_SELECTED = (state) => {
  return state.question_selected;
};

export default {
  GET_QUESTIONS_COURSE,
  GET_LOADDING,
  GET_QUESTION_EDIT, 
  GET_QUESTION_SELECTED
};
